import { render, staticRenderFns } from "./LoanCard.vue?vue&type=template&id=3384815e&"
import script from "./LoanCard.vue?vue&type=script&lang=ts&"
export * from "./LoanCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports